module.exports = __webpack_public_path__ + "img/clientes_unicos.132d576d.png";